import React from 'react';
import { MetaHead } from '../components/MetaHead';
import { SCRAPED_PAGES, COMPANY_INFO, COMMON_CONTACT_CALLOUT } from '../data/scrapedData';

export function ParagrafPage() {
  const p = SCRAPED_PAGES.paragraf;

  return (
    <>
      <MetaHead title={p.title} description={p.metaDescription} />

      <section className="bg-[#1C1C1E] text-white py-14 sm:py-18">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs uppercase tracking-widest font-semibold text-[#3885B8] block mb-2">
            Lovgivningsmæssige Rammer
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-white mb-2">
            {p.h1}
          </h1>
          <p className="text-lg text-white/90 font-medium">
            {p.subH1}
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          
          <div className="bg-white p-8 sm:p-10 rounded-2xl border border-[#1C1C1E]/10 shadow-xs space-y-6">
            <p className="text-base text-[#1C1C1E]/80 leading-relaxed italic border-b border-[#1C1C1E]/10 pb-4">
              {p.intro}
            </p>

            {p.sections.map((sec, idx) => (
              <div key={idx} className="space-y-3 pt-2">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4 border-l-4 border-[#1C1C1E] pl-3">
                  {sec.h2}
                </h2>
                {sec.paragraphs.map((para, pIdx) => (
                  <p key={pIdx} className="text-sm sm:text-base text-[#1C1C1E]/80 leading-relaxed">
                    {para}
                  </p>
                ))}
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Callout */}
      <section className="py-12 bg-white border-t border-[#1C1C1E]/10">
        <div className="max-w-7xl mx-auto px-4 text-center space-y-4">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4">{COMMON_CONTACT_CALLOUT.header}</h2>
          <p className="text-sm text-[#1C1C1E]/80 leading-relaxed">{COMMON_CONTACT_CALLOUT.p1}</p>
          <div className="pt-2 flex justify-center gap-4">
            <a href={COMPANY_INFO.phoneTel} className="bg-[#3885B8] hover:bg-[#2A6E9B] text-white px-5 py-2.5 rounded-lg font-semibold text-sm whitespace-nowrap">
              Ring {COMPANY_INFO.phone}
            </a>
            <a href={COMPANY_INFO.emailMailto} className="border border-[#3885B8] text-[#3885B8] hover:bg-[#3885B8]/10 px-5 py-2.5 rounded-lg font-semibold text-sm whitespace-nowrap">
              Skriv til os
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
